module.exports = __webpack_public_path__ + "media/images/mindset/icon-mindset-23f59e7f6768aa1ed25faa9e66fcd932.svg";